(() => {
  if (typeof URLSearchParams === 'undefined') return;

  const applyAttribution = () => {
    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('.tb-contact__form').forEach((form) => {
      const inquiryPage = form.querySelector('[data-tb-inquiry-page]');
      if (inquiryPage) inquiryPage.value = `${window.location.origin}${window.location.pathname}`;

      form.querySelectorAll('[data-tb-attribution]').forEach((field) => {
        const key = field.getAttribute('data-tb-attribution');
        const value = key ? (params.get(key) || '').trim().slice(0, 200) : '';
        field.value = value;
        field.disabled = !value;
      });
    });
  };

  const scheduleAttribution = () => {
    applyAttribution();
    window.setTimeout(applyAttribution, 250);
    window.setTimeout(applyAttribution, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAttribution, { once: true });
  } else {
    scheduleAttribution();
  }

  window.addEventListener('pageshow', scheduleAttribution);
})();
